import { render, staticRenderFns } from "./FormLiite.vue?vue&type=template&id=bd51c1ce&scoped=true&"
import script from "./FormLiite.vue?vue&type=script&lang=js&"
export * from "./FormLiite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd51c1ce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VFileInput,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd51c1ce')) {
      api.createRecord('bd51c1ce', component.options)
    } else {
      api.reload('bd51c1ce', component.options)
    }
    module.hot.accept("./FormLiite.vue?vue&type=template&id=bd51c1ce&scoped=true&", function () {
      api.rerender('bd51c1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormLiite.vue"
export default component.exports